var _path, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRoofLinemockup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 56,
    viewBox: "0 0 63 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 3.5L3.5166 35.8433L13.9432 51.5772L24.6047 44.4382L22.2563 41.0097L59.0313 15.8355L50 3.5Z",
    fill: "#5CC244",
    fillOpacity: 0.2,
    stroke: "#5CC244",
    strokeWidth: 1.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 51.5,
    r: 3.5,
    fill: "#404B54",
    stroke: "#5CC244",
    strokeWidth: 1.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 43.5,
    r: 3.5,
    fill: "#404B54",
    stroke: "#5CC244",
    strokeWidth: 1.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 16.5,
    r: 3.5,
    fill: "#404B54",
    stroke: "#5CC244",
    strokeWidth: 1.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 4.5,
    r: 3.5,
    fill: "#404B54",
    stroke: "#5CC244",
    strokeWidth: 1.6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 36.5,
    r: 3.5,
    fill: "#404B54",
    stroke: "#5CC244",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoofLinemockup);
export default __webpack_public_path__ + "static/media/icon_roof_linemockup.98398d772b80b0055a4d3757c92b5aaa.svg";
export { ForwardRef as ReactComponent };